import { connect } from 'react-redux';
import { selectViewportWidth } from 'selectors/ui';
import GrowingTextarea from './GrowingTextarea';

const mapStateToProps = state => ({
  viewportWidth: selectViewportWidth(state),
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(GrowingTextarea);
